'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OK = exports.OK = 200;
var NO_CONTENT = exports.NO_CONTENT = 204;
var GONE = exports.GONE = 410;